import React from "react";
import { Route, Redirect } from "react-router-dom";
import { isLogin } from "../../authorization/isLogin";

export const PrivateRoute = ({ component: Component, ...rest }) => {
  const x = isLogin() 
  return (
    <Route
      {...rest}
      render={(props) =>
        isLogin() ? <Component {...props} /> : <Redirect to="/admin" />
      }
    />
  );
};